import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)({
  minHeight: "36px",
  display: "flex",
  alignItems: "center",
});

export const DocumentRequestsContainer = styled(Grid)({
  minWidth: "60px",
  display: "flex",
  flexFlow: "row",
  alignItems: "right",
  cursor: "pointer",

  "& svg": {
    fontSize: "1.3em",
  },

  "& p": {
    fontSize: "0.7em",
  },
});
